export const HOST_API = process.env.VUE_APP_WEBAPI_URL;

// export const HOST_API = process.env.VUE_APP_WEBAPU_TEST_URL;
